<template>
<div></div>
</template>

<script>
  import localforage from 'localforage'
  import hotkeys from "hotkeys-js";
  export default {
    name: 'keywords',
    props: {
      genPrice: {
        type: Function,
        default: null
      },
      doCopy: {
        type: Function,
        default: null
      },
      reset: {
        type: Function,
        default: null
      },
      gokTotalPrice: {
        type: Function,
        default: null
      },
    },
    data(){
      return{
        keys:[]
      }
    },
    mounted(){
      let that=this
     this.getHortcutsKey()
    },
    methods:{
      //获取全局快捷键
      getHortcutsKey(){
        let that=this
        let user = this.$store.getters['user']
        localforage.getItem('key_' + user.accountNo).then(keys=>{
          if (keys != null) {
            that.keys = JSON.parse(keys)
          } else {
            that.keys = that.$store.getters['keys']
            localforage.setItem('key_'+user.accountNo,JSON.stringify(that.keys))
          }
          hotkeys.filter = function(event) {
            return true
          }
          that.bindKey()
        })
      },
      //绑定全局快捷键设置
      bindKey(){
        let that =this
        that.keys.forEach(item=>{
            if(item.code=='price'){
              hotkeys(item.keyCode, {keyup: true},(e)=>{
                if(that.genPrice==null)return false
                if (event.type === 'keyup') {
                  if(that.$parent.$refs.btnGen!=null){
                    that.$parent.$refs.btnGen.$el.focus()
                  }
                  that.genPrice();
                }
              })
            }
            if(item.code=='discounts'){
              hotkeys(item.keyCode,{keyup: true},(e)=>{
                if(that.gokTotalPrice==null)return false
                if (event.type === 'keyup') {
                  if(that.$parent.$refs.btnDis!=null){
                    that.$parent.$refs.btnDis.$el.focus()
                  }
                  that.gokTotalPrice()
                }
              })
            }
            if(item.code=='copy'){
              hotkeys(item.keyCode,{keyup: true},(e)=>{
                if(that.doCopy==null)return false
                if (event.type === 'keyup') {
                  that.doCopy()
                }
              })
            }
            if(item.code=='reset'){
              hotkeys(item.keyCode,{keyup: true},(e)=>{
                if(that.reset==null)return false
                if (event.type === 'keyup') {
                  that.reset()
                }
              })
            }
        })
      },
      hotkeyDestroyed(){
        let that=this
        that.keys.forEach(item=>{
          hotkeys.unbind(item.keyCode)
        })
      },
    },
    destroyed(){
      let that=this
      // 销毁enter事件
      this.hotkeyDestroyed()
    },
    beforeDestroy(){
      // 销毁enter事件
      this.hotkeyDestroyed()
    },
  }
</script>

<style scoped>

</style>
